var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mainSpinner)?_c('div',{staticClass:"block-spinner"},[_c('img',{staticClass:"spinner",class:{ 'spninner-small': _vm.$vuetify.breakpoint.smAndDown},attrs:{"src":require("../../assets/images/loading.gif"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }